import app from './app'
import auth from './auth'
import competitions from './competitions'
import entry from './entry'
import players from './players'
import settings from './settings'

export default {
  app,
  auth,
  competitions,
  entry,
  players,
  settings
}
